import React from "react";
import HeroSection from "./components/HeroSection";
import ChatSection from "./components/ChatSection";
import { DashboardSection } from "./components/DashboardSection"; 
import { MapSection } from "./components/MapSection";
import { useEffect } from 'react';
import axios from 'axios';

const warmupUrls = [
  'https://flood-forecast-yadn.onrender.com/',
  'https://flood-chat-kmmr.onrender.com/',
  'https://luma-flood-algo-be.onrender.com/'
];


function App() {
  useEffect(() => {
    // Fire warmup requests (non-blocking)
    warmupUrls.forEach(url => {
      axios.get(url).catch(() => {}); // Ignore errors
    });
  }, []);
  
  return (
    <div className="App">
      <HeroSection />
      <DashboardSection />
      <MapSection />
      <ChatSection />
    </div>
  );
}

export default App;




// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
